import { MultiFactorInfo } from 'firebase/auth';
import * as React from 'react';
import styled from 'styled-components';
import { ControlSpacer } from '../../../shared/form/ControlSpacer';
import { ErrorText } from '../../../shared/form/ErrorMessage';
import { SuccessMessage } from '../../../shared/form/SuccessMessage';
import { TextField } from '../../../shared/form/TextField';

export interface ISecondFactorVerificationProps {
  verificationCode: string;
  onVerificationCodeChange: (value: string) => void;
  selectedFactor: MultiFactorInfo | null;
  showResendSuccess?: boolean;
  error?: string;
}

export const SecondFactorVerification = React.memo(
  (props: ISecondFactorVerificationProps): React.ReactElement => {
    const isPhoneFactor = props.selectedFactor?.factorId === 'phone';

    return (
      <React.Fragment>
        <h1 style={{ margin: '.5rem 1rem' }}>Enter Verification Code</h1>
        <InputContainer role='form'>
          <ControlSpacer>
            <TextField
              name='verificationCode'
              label='Verification Code'
              type='text'
              style={{ width: '100%' }}
              value={props.verificationCode}
              onChange={props.onVerificationCodeChange}
              role='textbox'
            />
          </ControlSpacer>
          {props.error && <ErrorText>{props.error}</ErrorText>}
          {props.showResendSuccess && (
            <SuccessMessage>Verification code resent successfully</SuccessMessage>
          )}
          {isPhoneFactor && (
            <HelpText>
              A verification code has been sent to your phone via SMS
            </HelpText>
          )}
        </InputContainer>
      </React.Fragment>
    );
  },
  (
    prevProps: Readonly<ISecondFactorVerificationProps>,
    nextProps: Readonly<ISecondFactorVerificationProps>
  ): boolean => {
    return (
      prevProps.verificationCode === nextProps.verificationCode &&
      prevProps.error === nextProps.error &&
      prevProps.showResendSuccess === nextProps.showResendSuccess &&
      prevProps.selectedFactor === nextProps.selectedFactor &&
      prevProps.onVerificationCodeChange === nextProps.onVerificationCodeChange
    );
  }
);

SecondFactorVerification.displayName = 'SecondFactorVerification';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  padding-top: 0px;
  width: 100%;
  height: 100%;
`;

const HelpText = styled.p`
  font-size: 13px;
  color: var(--color-text-secondary, #666);
  margin: 8px 0 0 0;
  line-height: 1.5;
`;
